import { observer } from 'mobx-react-lite';
import Image from 'next/image';

import Button from '@/components/common/Button/Button';
import MobileFilter from '@/components/menuV2/MobileFilter/MobileFilter';
import type {
  FilterRecordModelType,
  MenuSortOptionRecordModelType,
} from '@/models/api';
import { useStore } from '@/models/root-store';

interface IFilterSortContainerMobile {
  filterCmsData: FilterRecordModelType;
  sortCmsData: MenuSortOptionRecordModelType[];
  primaryCategory: string;
  search?: boolean;
}

export const FilterSortContainerMobile: React.FC<IFilterSortContainerMobile> =
  observer(({ filterCmsData, sortCmsData, primaryCategory, search }) => {
    const filtersData = filterCmsData?.sections;
    const sorts = sortCmsData;
    const {
      productStore: { filters, productsCount },
    } = useStore();
    const {
      selectedFilters,
      isSortSelected,
      clearFilters,
      setCurrentSelectedFilter,
      filterCount,
    } = filters;
    const { isFiltered, setFilter } = selectedFilters;

    const handleClearFilters = () => {
      clearFilters();
    };
    return (
      <div className="flex h-[780px] flex-col justify-between">
        <div className="space-y-3">
          <div className="sticky top-0 z-[1] bg-white px-4">
            <div className="flex justify-between pt-3.5">
              <span className="font-interBold text-2xl">
                Filter & sort
                <span className="ml-2 font-interMedium text-base text-grey-dark">
                  ({filterCount})
                </span>
              </span>
              <div>
                <button id="close" onClick={filters.closeFilter}>
                  <Image
                    id="close"
                    src="/assets/icons/close_icon.svg"
                    alt="close"
                    width={18}
                    height={18}
                  />
                </button>
              </div>
            </div>
            <div className="pb-4 pt-3 font-interMedium capitalize text-grey-dark">
              {primaryCategory}
            </div>
          </div>

          <MobileFilter
            search={search}
            sorts={sorts}
            filtersData={filtersData}
            isSortSelected={isSortSelected}
            setCurrentSelectedFilter={setCurrentSelectedFilter}
            filters={filters}
            setFilter={setFilter}
            isFiltered={isFiltered}
          />
          {/* View Items Stick Button */}
        </div>
        {filters.isFilterOpen && (
          <div className="sticky bottom-0 z-1001 flex w-full justify-between border-t bg-white px-6 py-4">
            <button
              className="text-blueberry"
              type="button"
              onClick={handleClearFilters}
            >
              Clear all filters
            </button>

            <Button
              theme="tertiary"
              onClick={filters.closeFilter}
              className="max-w-sm"
            >
              View {productsCount} items
            </Button>
          </div>
        )}
      </div>
    );
  });
